var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_853_3853)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_853_3853",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V80H80V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_853_3853)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_853_3853",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H80V80H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_853_3853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4379 76.793H41.4331C46.6023 76.793 49.8331 71.1972 47.2485 66.7205L32.2057 40.6655V27.1852H17.9095V40.6655L2.86666 66.7205C0.282133 71.1972 3.51276 76.793 8.68213 76.793H28.7501",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6047 24.685V19.685H45.7812V32.46C40.6311 34.7537 36.4719 38.8693 34.125 43.9912",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.082 74.9305C48.8789 76.1289 51.9586 76.793 55.1945 76.793C67.9883 76.793 78.3586 66.4227 78.3586 53.6305C78.3586 44.1883 72.7102 36.068 64.6072 32.4602V29.373",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3417 21.0921H15.7733C14.0906 21.0921 12.7266 22.4562 12.7266 24.1388C12.7266 25.8215 14.0906 27.1855 15.7733 27.1855H34.3417C36.0244 27.1855 37.3884 25.8215 37.3884 24.1388C37.3884 22.4562 36.0244 21.0921 34.3417 21.0921Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3412 13.5921H43.8356C42.1531 13.5921 40.7891 14.9562 40.7891 16.6388C40.7891 18.3215 42.1531 19.6855 43.8356 19.6855H66.8064C68.4891 19.6855 69.8531 18.3215 69.8531 16.6388C69.8531 14.9562 68.4891 13.5921 66.8064 13.5921H62.0291",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1289 70.6992C50.3069 71.6055 52.693 72.1055 55.1945 72.1055C65.3836 72.1055 73.6711 63.818 73.6711 53.6305C73.6711 48.5195 71.5539 43.7367 67.9945 40.3102H42.3961C39.8539 42.757 38.0477 45.8977 37.2227 49.3539",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1367 49.9183H17.9815L6.9276 69.0642C6.41838 69.9462 6.70901 70.713 6.9276 71.0916C7.14619 71.4703 7.66494 72.1055 8.68354 72.1055H41.4346C42.4531 72.1055 42.972 71.4703 43.1904 71.0917C43.4092 70.713 43.6998 69.9461 43.1906 69.0641L32.1367 49.9183Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_853_3853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSus3);
export default __webpack_public_path__ + "static/media/sus3.4cc9b5959cf00a43cdd5f6fdfd3125b7.svg";
export { ForwardRef as ReactComponent };